import { useTranslation } from 'react-i18next';
import { BannerContainer } from './PromBanner.styled';

interface PromBannerProps {
  visible: boolean;
  onClick: () => void;
  phase?: 'baseline' | 'retest';
}

export function PromBanner({ visible, onClick, phase }: PromBannerProps) {
  const { t } = useTranslation();

  const message = phase === 'baseline'
    ? t('prom.baselinePrompt', 'Complete your initial wellness assessment — it only takes a few minutes')
    : t('prom.retestPrompt', 'Time for your periodic wellness reassessment — it only takes a few minutes');

  return (
    <BannerContainer visible={visible} onClick={onClick}>
      {message}
    </BannerContainer>
  );
}
